import React from 'react'
import './AboutSaveIT.css'

export const AboutSaveIT = () => {
  return (
    <div id="about-saveit">
        <center>
            <h1 style={{color:"rgb(255,255,255)", fontSize:"40px"}}>About SaveIT</h1><br/><br/>
            <p style={{color:"rgb(255,255,255)"}}>
                SaveIT is a Web Application developed to help Users to save their content (Text/Files)<br/>
                and access/retrieve it anywhere on any system over the internet.<br/>
                More new features coming soon...<br/>
                Stay Tuned 🌐
            </p><br/><br/>
            <center>
            <div>
                <img src='react.png' id="react" style={{width:"100px"}}></img>
                <img src='logo-built_white.png' style={{width:"150px"}}></img>
            </div>
            </center>
            
        </center>
    </div>
  )
}